export default "__VITE_ASSET__C3fACM6x__"